// extracted by mini-css-extract-plugin
export default {"container":"Jh-z","bubbleNav":"Kh-z","graphic":"Lh-z","contact":"Mh-z"};